const wechatUrl = route => {
  const url = 'https://activity.wuzheng.com.cn/'
  // const url = 'http://localhost:8080/'
  const query = route.query
  let queryStr = ''
  if (query) {
    for (const key in query) {
      queryStr += `${key}=${query[key]}&`
    }
  }
  const path = route.path
  // https://discovery-dev.wuzheng.com.cn/vote/?path=/home
  return url + '?' + queryStr + 'path=' + path
}

const wechatUrlParse = url => {
  // 授权判断
  // https://activity.wuzheng.com.cn/?code=031SsGFa1lnZ4D0ysfJa1hkFQ60SsGF9&state=STATE#/home
  if (url.indexOf('https://activity.wuzheng.com.cn/?code=') > -1) {
    // if (url.indexOf('8080/?code=') > -1) {
    const urlArr = url.split('/?')
    // [0] https://activity.wuzheng.com.cn/
    // [1] code=031SsGFa1lnZ4D0ysfJa1hkFQ60SsGF9&state=STATE#/home
    const rightUrlArr = urlArr[1].split('#/')
    // [0] code=091lDIkl2mLmU844PZll2yjKqE4lDIkk&state=STATE
    // [1] home
    // 拼接url, 跳转
    return `${urlArr[0]}/#${rightUrlArr[1]}?${rightUrlArr[0]}`
  } else if (url.indexOf('https://activity.wuzheng.com.cn/?') > -1) {
    // 分享判断
    // https://activity.wuzheng.com.cn/?path=/home#/ 开发环境
    const urlArr = url.split('/?')
    // [0] https://activity.wuzheng.com.cn/
    // [1] path=/home#/
    const rightUrlArr = urlArr[1].split('path=')
    // [0]
    // [1] /home#/

    // 优化，去除#/
    const pathArr = rightUrlArr[1].split('#/')
    // pathArr[0] /home

    // 判断有没有参数
    if (rightUrlArr[0]) {
      return urlArr[0] + '/#' + pathArr[0] + '?' + rightUrlArr[0]
    } else {
      return urlArr[0] + '/#' + pathArr[0]
    }
  }

  return false
}

// 函数节流
export function throttle(fn, interval) {
  var enterTime = 0 //触发的时间
  var gapTime = interval || 300
  return function () {
    var context = this
    var backTime = new Date()
    if (backTime - enterTime > gapTime) {
      fn.call(context, arguments)
      enterTime = backTime
    }
  }
}

// 函数防抖
export function debounce(fn, interval) {
  let timer
  let gapTime = interval || 500
  return function () {
    timer && clearTimeout(timer)
    let context = this
    let args = arguments
    timer = setTimeout(function () {
      fn.call(context, args)
    }, gapTime)
  }
}

export {wechatUrl, wechatUrlParse}
